// CJ - initialize everything from here
// CJ - Use JS isolation? maybe as a function of AppComponent?
// CJ - Some type of registry here?

import { IJSModule } from "./IJSModule.js";
import { BTService } from "./BT/BTService.js";
import { CookieHelpers } from "./CookieHelpers.js";
import { CredentialManagementAPIHelpers } from "./CredentialManagementAPIHelpers.js";
import { DeliveryConnectHelpers } from "./DeliveryConnectHelpers.js";
import { HIDService } from "./HID/HIDService.js";
import { HotJarManager } from "./HotJar/HotJarManager.js";
import { HSLCanvasService } from "./HSLCanvas.js";
import { KeyboardHelpers } from "./KeyboardHelpers.js";
import { MarkdownRendererHelpers } from "./MarkdownRendererHelpers.js";
import { MediaHelpers } from "./MediaHelpers.js";
import { TelerikEditorHelpers } from "./TelerikEditorHelpers.js";
import { TestFunctions } from "./TestFunctions.js";
import { Theming } from "./Theming/Theming.js";
import { UIHelpers } from "./UIHelpers.js";
import { USBService } from "./USB/USBService.js";
import { UserPilotHelpers } from "./UserPilotHelpers.js";
import { WebCamManager } from "./WebCam/WebCamManager.js";
import { ClearentHelpers } from "./ClearentHelpers.js";
import { LoadScriptsHelpers } from "./LoadScriptsHelpers.js";

try {
    let Services: object[] =
        [
            BTService.prototype,
            ClearentHelpers.prototype,
            CookieHelpers.prototype,
            CredentialManagementAPIHelpers.prototype,
            DeliveryConnectHelpers.prototype,
            HIDService.prototype,
            HotJarManager.prototype,
            HSLCanvasService.prototype,
            KeyboardHelpers.prototype,
            MarkdownRendererHelpers.prototype,
            TelerikEditorHelpers.prototype,
            TestFunctions.prototype,
            Theming.prototype,
            UIHelpers.prototype,
            USBService.prototype,
            UserPilotHelpers.prototype,
            WebCamManager.prototype,
            MediaHelpers.prototype,
            LoadScriptsHelpers.prototype
        ];

    Services.forEach((sp, index, items) => {
        var svc: IJSModule = Object.create(sp);

        let result = svc.initialize();

        if (!result) {
            alert(`JS Service initialization failed - ${svc.serviceName}`);
        }
        else {
            console.log(`Initialized Service ${svc.serviceName}`);
        }
    });
}
catch (e) {
    alert(`Error in Service Initialization - ${e}`);
}
